var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRbNrRailTrafficOperations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z",
    transform: "translate(-85 -1494) translate(85 1494)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.492 25.668l-.742-1.585h.65l-.455-.987h-.67l-.622-1.332h.765l-.455-.987h-.789l-.529-1.077 2.536-1.562v-7.51l-.909-1.4.048-2.274S33.415 5 27.961 5 22.6 6.952 22.6 6.952l.048 2.274-.909 1.4v7.487l2.416 1.493-.55 1.171h-1.05l-.455.987h1.029l-.622 1.336h-1.052l-.455.984h1.029l-.742 1.585h1.148l.742-1.562h9.449l.742 1.585h1.124zm-1.866-8.451a.694.694 0 1 1-.694-.666.653.653 0 0 1 .694.666zM28.775 6.148s2.344.253 3.158 1.033V9.2l-3.158-.712zm-.813 3.9a.919.919 0 1 1-.957.919.941.941 0 0 1 .956-.915zM23.823 7.2c.813-.781 3.158-1.033 3.158-1.033v2.37l-3.158.712zm0 10.013a.694.694 0 1 1 .694.666.681.681 0 0 1-.694-.662zM25.115 20h5.55l.383.781h-6.316zm1.053 3.1h-2.537l.622-1.332h7.224L32.1 23.1z",
    transform: "translate(-85 -1494) translate(69 1491)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRbNrRailTrafficOperations);
export default __webpack_public_path__ + "static/media/rb-nr-rail-traffic-operations.85823e4513fc04a52255b860b1994fb4.svg";
export { ForwardRef as ReactComponent };